var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextdefaulthover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6H29C29.4729 6 30 6.42504 30 7.13043V24.8696C30 25.575 29.4729 26 29 26H3C2.52708 26 2 25.575 2 24.8696V7.13043C2 6.42504 2.52708 6 3 6ZM0 7.13043C0 5.40154 1.34315 4 3 4H29C30.6569 4 32 5.40154 32 7.13043V24.8696C32 26.5985 30.6569 28 29 28H3C1.34315 28 0 26.5985 0 24.8696V7.13043ZM8 19C7.44772 19 7 19.4477 7 20V22C7 22.5523 7.44772 23 8 23H20C20.5523 23 21 22.5523 21 22V20C21 19.4477 20.5523 19 20 19H8Z",
    fill: "#151514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextdefaulthover);
export default __webpack_public_path__ + "static/media/textdefaulthover.a3f036d9.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextdefaulthover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6H29C29.4729 6 30 6.42504 30 7.13043V24.8696C30 25.575 29.4729 26 29 26H3C2.52708 26 2 25.575 2 24.8696V7.13043C2 6.42504 2.52708 6 3 6ZM0 7.13043C0 5.40154 1.34315 4 3 4H29C30.6569 4 32 5.40154 32 7.13043V24.8696C32 26.5985 30.6569 28 29 28H3C1.34315 28 0 26.5985 0 24.8696V7.13043ZM8 19C7.44772 19 7 19.4477 7 20V22C7 22.5523 7.44772 23 8 23H20C20.5523 23 21 22.5523 21 22V20C21 19.4477 20.5523 19 20 19H8Z",
    fill: "#151514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextdefaulthover);
export default __webpack_public_path__ + "static/media/textdefaulthover.a3f036d9.svg";
export { ForwardRef as ReactComponent };